module.exports = __webpack_public_path__ + "img/grey_018.0393e415.png";